import type { ReactNode } from 'react';

import { Surface } from '@storebrand-digital/pretzel';

import { getInverseBackground } from './getInverseBackground';
import { HeaderFooterGrid } from './HeaderFooterGrid';
import type { HeaderFooterTheme } from './types';
import { WebViewFormFooter } from './FormVariant/WebViewFormFooter';

interface Props {
  children: ReactNode;
  locale: 'no' | 'en';
  theme: HeaderFooterTheme;
}

export function WebViewLayout({ children, locale, theme }: Props) {
  return (
    <HeaderFooterGrid>
      <div />

      <Surface
        isBackground
        lightThemeBackgroundLayer={theme}
        className="flex flex-col box-border"
      >
        {children}
      </Surface>

      <Surface
        isBackground
        lightThemeBackgroundLayer={getInverseBackground(theme)}
      >
        <WebViewFormFooter locale={locale} />
      </Surface>
    </HeaderFooterGrid>
  );
}
